import { render } from "./HelloWorld.vue?vue&type=template&id=4c345b7a&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=4c345b7a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4c345b7a"

export default script